const contact = {
  eyebrow: 'Get in Touch',
  title: 'Contact Us',
  intro: 'Have questions about our Ceylon cinnamon products? We\'d love to hear from you. Write to us and we\'ll reply within one business day.',

  quick: { label: 'Quick contact', whatsapp: 'WhatsApp', call: 'Call', email: 'Email' },

  infoTitle: 'Let\'s Connect',
  infoText: 'Whether you\'re interested in wholesale orders, have questions about our products, or want to learn more about Ceylon cinnamon, we\'re here to help.',
  info: {
    address: 'Sri Lanka estate',
    addressValue: '264/A, Regiland Estate, Batapola, Sri Lanka',
    singapore: 'Singapore office',
    singaporeValue: '6 Telok Blangah Crescent, #02-01, Singapore',
    email: 'Email',
    phone: 'Phone',
    places: { sriLanka: 'Sri Lanka', singapore: 'Singapore' },
    whatsapp: 'WhatsApp',
    whatsappValue: 'Chat with us now',
    hours: 'Business Hours',
    hoursValue: 'Mon - Fri: 9:00 AM - 6:00 PM (Sri Lanka time, GMT+5:30)',
  },
  social: 'Connect With Us',

  form: {
    title: 'Send a Message',
    quoteTitle: 'Request a Quote',
    name: 'Your Name',
    namePlaceholder: 'John Doe',
    email: 'Email Address',
    emailPlaceholder: 'john@example.com',
    message: 'Message',
    messagePlaceholder: 'Tell us about your requirements...',
    samplesTitle: 'Request Samples',
    // Email subject for a plain message (quotes and samples have their own)
    subject: 'Website enquiry',
    send: 'Send Message',
    sending: 'Sending...',
    errorGeneric: 'Something went wrong. Please try again.',
    errorNetwork: 'Failed to send message. Please try again later.',
    // Shown under either error, with the email address and a WhatsApp link
    fallback: { before: 'You can also email ', or: ' or ', whatsapp: 'message us on WhatsApp', after: '.' },
  },

  // Pre-filled when arriving from the Products quote list (?product=C4, H1)
  quote: {
    subject: (products) => `Quote request: ${products}`,
    quantityLine: (product) => `${product}, quantity:`,
    rest: '\n\nPackaging:\nDestination port:\n',
  },

  // Pre-filled when arriving from a "Request samples" link (?type=samples, maybe with ?product=)
  samples: {
    subject: (products) => (products ? `Sample request: ${products}` : 'Sample request'),
    message: (products) => `${products ? `Samples of: ${products}\n` : 'Grades I\'d like to sample:\n'}Delivery address:\nIntended use:\n`,
  },

  success: {
    title: 'Thank You!',
    text: 'Your message has been sent successfully. We\'ll reply within one business day.',
    again: 'Send Another Message',
  },
};

export default contact;
